export default "__VITE_PUBLIC_ASSET__f0219779__"